module.exports = __webpack_public_path__ + "static/media/press_diario-pe.f28b54fd.jpg";